module.exports = __webpack_public_path__ + "img/test_i.7f25fb15.png";